import type { ReactElement } from 'react';
import '@styles/components/_language-loading-popup.scss';
import type { Language } from '@models/i18n/language.model';
import { useAppStore, selectLanguage } from '@store/app.store';
import enLogo from '@shared/icons/Logo.png';
import arLogo from '@shared/icons/Ar_Logo.png';

interface LanguageLoadingPopupProps {
  message?: string;
}

const DEFAULT_MESSAGE = 'Switching language...';

const LANGUAGE_LOGOS: Record<Language, string> = {
  en: enLogo,
  ar: arLogo,
  ru: enLogo,
};

export const LanguageLoadingPopup = ({
  message = DEFAULT_MESSAGE,
}: LanguageLoadingPopupProps): ReactElement => {
  const currentLanguage = useAppStore(selectLanguage);
  const logoSrc = LANGUAGE_LOGOS[currentLanguage || 'en'];

  return (
    <div className="language-loading-popup" role="status" aria-live="polite" aria-label={message}>
      <div className="language-loading-popup__backdrop" aria-hidden="true" />
      <div className="language-loading-popup__content" aria-hidden="true">
        <img className="language-loading-popup__brand-logo" src={logoSrc} alt="" />
        <span className="language-loading-popup__spinner" />
      </div>
      <span className="language-loading-popup__message">{message}</span>
    </div>
  );
};
